import { diffIn } from './dateHelpers'

export function dateRangeDayCounter(startDate: Date, endDate: Date): number {
  return Math.abs(diffIn(endDate, startDate, 'days')) + 1
}

export const startOfDay = (date: Date) => {
  const newDate = new Date(date)
  newDate.setHours(0, 0, 0, 0)
  return newDate
}

export const endOfDay = (date: Date) => {
  const newDate = new Date(date)
  newDate.setHours(23, 59, 59, 999)
  return newDate
}

export const localStartOfDay = () => {
  return startOfDay(new Date())
}

export const localEndOfDay = () => {
  return endOfDay(new Date())
}
